export enum stowageFeatureEnum {
    ViewStowagePlan,
    EditStowage,
    EditShipFigure,
    Publish,
    Promote,
    SynchronizeWithImos,
    GenerateReport,
    AdjustCargoTemperature,
    BlockTank,
    AcceptSoftRuleViolation,
    AutoStow,
    EmptyTankPlan,
    EditRotation,
    EditCargo,
}
